<template>
  <ChatbotAboutLayout
    title="EQRC Dashboard"
    what-it-is-subtitle="Visualise Europe's quantum ecosystem"
    :description-paragraphs="descriptionParagraphs"
    :features="features"
    audience-subtitle="For researchers, policymakers, and analysts"
    :audience-items="audienceItems"
    :resources="resources"
    try-it-subtitle="Explore the dashboard"
    :embed="embed"
    :embed-intro="embedIntro"
  />
</template>

<script>
import ChatbotAboutLayout from "@/components/ChatbotAboutLayout.vue";

const DASHBOARD_URL = "https://dashboard.hybridintelligence.eu/";

export default {
  components: {
    ChatbotAboutLayout,
  },
  setup() {
    const descriptionParagraphs = [
      "How is Europe investing in quantum research? Where is the global quantum workforce growing? The EQRC Dashboard turns complex ecosystem data into interactive visualisations you can filter, compare, and explore.",
      "Built by the European Quantum Readiness Center, it brings together two views: EU-funded quantum projects and global quantum job trends, in one place.",
    ];

    const features = [
      {
        title: "Explore EU quantum projects",
        text: "Browse CORDIS-funded initiatives by country, pillar, impact area, and funding, and compare how resources are distributed across Europe.",
      },
      {
        title: "Track global job trends",
        text: "Analyse degree levels, roles, pillars, locations, and company profiles from EQRC's quantum workforce research.",
      },
      {
        title: "Drill down your way",
        text: "Apply filters, view side-by-side comparisons, inspect detailed tables, and ask the built-in assistant questions about the data you're viewing.",
      },
    ];

    const audienceItems = [
      {
        title: "Who it's for",
        text: "Researchers, policymakers, educators, and industry analysts tracking Europe's quantum landscape and workforce.",
      },
      {
        title: "Best use cases",
        text: "Funding analysis, workforce benchmarking, teaching demonstrations, and evidence for strategy or policy documents.",
      },
      {
        title: "Recurring usefulness",
        text: "Return when you need updated figures for reports, presentations, or to monitor how the ecosystem evolves over time.",
      },
    ];

    const resources = [
      {
        label: "CORDIS database",
        href: "https://cordis.europa.eu/",
        description: "Source data for EU-funded quantum research projects.",
      },
      {
        label: "European Quantum Flagship",
        href: "https://qt.eu/",
        description: "Context on the flagship initiative behind the dashboard.",
      },
    ];

    const embed = {
      src: DASHBOARD_URL,
      title: "EQRC Dashboard",
    };

    const embedIntro =
      "Use the embedded dashboard below to explore EU-funded quantum projects and global quantum job trends. Filter, compare, and drill into the data, or ask the built-in assistant about what you are viewing.";

    return {
      descriptionParagraphs,
      features,
      audienceItems,
      resources,
      embed,
      embedIntro,
    };
  },
};
</script>
